import React from 'react';
// 用于表格中换行
function ABSBreakTdContent(props: any) {
  const { children } = props;
  return <div style={{wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: '24px'}}>{children}</div>;
}

export default ABSBreakTdContent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSBreakTdContent/index.tsx